import styled from "styled-components";
import { ColorV2 } from "config/colors";
import { TypographyV2 } from "config/font";

export const DayLabelButton = styled.button`
  ${TypographyV2.h3};
  padding: 0;
  border: none;
  color: ${ColorV2.Blue1};
  background: transparent;
  cursor: pointer;
  transition: color 150ms ease;

  &:hover {
    color: ${ColorV2.Blue3};
  }
`;
